/*
  Maison Milan — search panel visibility.

  Dawn's predictive search renders into [data-predictive-search]. The resting
  panel (trending terms and top products) hides as soon as the field has a
  query, rather than waiting for results to arrive — otherwise the two stack
  for a beat on every keystroke.
*/
class MaisonSearch extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('[data-search-default]');
    this.input = this.querySelector('input[type="search"]');
    if (!this.panel || !this.input) return;

    this.input.addEventListener('input', this.sync);
    // A reset button clears the field without firing input in some browsers.
    this.addEventListener('click', this.onClick);
    this.sync();
  }

  disconnectedCallback() {
    if (this.input) this.input.removeEventListener('input', this.sync);
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    if (!event.target.closest('[type="reset"]')) return;
    // Runs after the browser has cleared the field.
    requestAnimationFrame(this.sync);
  };

  sync = () => {
    this.panel.hidden = this.input.value.trim().length > 0;
  };
}

if (!customElements.get('maison-search')) {
  customElements.define('maison-search', MaisonSearch);
}
